import { SyncLoader } from "react-spinners";
import useAuthenticate from "../authentication/authenticate.js"; // use your hook
import "../properties/styles/detailedPropertyPanel.css";

const GroupedRoles = ({ roles, isLoading, error, onEditRole, onDeleteRole }) => {
    const { user, isLoading: authLoading } = useAuthenticate();

    const groupRoles = (roles) => {
        return roles.reduce((acc, role) => {
            const roleType = role.propertyRole?.role || "Unknown Role";

            if (!acc[roleType]) {
                acc[roleType] = [];
            }

            const user = role.propertyRole?.account?.user;
            const fullName = user
                ? `${user.givenName} ${user.lastName}`.trim()
                : "Unknown User";

            acc[roleType].push({ name: fullName, id: role._id, email: user?.email });
            return acc;
        }, {});
    };

    const groupedRoles = roles && groupRoles(roles);

    return (
        <div>
            {isLoading || authLoading ? (
                <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
                    <SyncLoader color="#a8a8a8" size={8} />
                </div>
            ) : error ? (
                <p className="error">{error}</p>
            ) : (
                <div className="roles-list">
                    {roles.length > 0 ? (
                        Object.keys(groupedRoles).map((roleType) => (
                            <div key={roleType} className="role-group">
                                <span className="role-type">
                                    <strong>
                                        {roleType.charAt(0).toUpperCase() + roleType.slice(1)}
                                    </strong>
                                </span>
                                <ul>
                                    {groupedRoles[roleType].map(({ name, email, id }) => (
                                        <li key={id} className="role-item">
                                            <div className="role-item-content">
                                                <span className="role-email">{name} ({email})</span>
                                                {/* Only show actions if current user is NOT an owner */}
                                                {!user?.active?.owner && (
                                                    <div className="role-actions">
                                                        <button
                                                            className="edit-role-button"
                                                            onClick={() => onEditRole(id)}
                                                        >
                                                            <i className="fas fa-edit"></i>
                                                        </button>
                                                        <button
                                                            className="delete-role-button"
                                                            onClick={() => onDeleteRole(id)}
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))
                    ) : (
                        <p>No roles found for this property.</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default GroupedRoles;
